import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgN600Aging = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 500 500",
	style: { enableBackground: "new 0 0 500 500" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M333.77,146.97h-25.17v-13.58c0-4.78-3.88-8.66-8.66-8.66c-4.78,0-8.66,3.88-8.66,8.66v13.58h-82.56v-13.58 c0-4.78-3.88-8.66-8.66-8.66c-4.78,0-8.66,3.88-8.66,8.66v13.58h-25.17c-16.75,0-30.38,13.63-30.38,30.38v167.55 c0,16.75,13.63,30.38,30.38,30.38h167.55c16.75,0,30.38-13.63,30.38-30.38V177.35C364.15,160.59,350.53,146.97,333.77,146.97z  M166.23,164.29h25.17v13.58c0,4.78,3.88,8.66,8.66,8.66c4.78,0,8.66-3.88,8.66-8.66v-13.58h82.56v13.58 c0,4.78,3.88,8.66,8.66,8.66c4.78,0,8.66-3.88,8.66-8.66v-13.58h25.17c7.2,0,13.05,5.86,13.05,13.05v28.57H153.17v-28.57 C153.17,170.15,159.03,164.29,166.23,164.29z M333.77,357.95H166.23c-7.2,0-13.05-5.86-13.05-13.05V223.24h193.65v121.66 C346.83,352.09,340.97,357.95,333.77,357.95z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M206.99,257.82h-21.95c-4.78,0-8.66,3.88-8.66,8.66c0,4.78,3.88,8.66,8.66,8.66h21.95 c4.78,0,8.66-3.88,8.66-8.66C215.65,261.7,211.77,257.82,206.99,257.82z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M260.97,257.82h-21.95c-4.78,0-8.66,3.88-8.66,8.66c0,4.78,3.88,8.66,8.66,8.66h21.95 c4.78,0,8.66-3.88,8.66-8.66C269.64,261.7,265.76,257.82,260.97,257.82z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M314.96,257.82h-21.95c-4.78,0-8.66,3.88-8.66,8.66c0,4.78,3.88,8.66,8.66,8.66h21.95 c4.78,0,8.66-3.88,8.66-8.66C323.62,261.7,319.74,257.82,314.96,257.82z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M206.99,306.04h-21.95c-4.78,0-8.66,3.88-8.66,8.66c0,4.78,3.88,8.66,8.66,8.66h21.95 c4.78,0,8.66-3.88,8.66-8.66C215.65,309.92,211.77,306.04,206.99,306.04z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M260.97,306.04h-21.95c-4.78,0-8.66,3.88-8.66,8.66c0,4.78,3.88,8.66,8.66,8.66h21.95 c4.78,0,8.66-3.88,8.66-8.66C269.64,309.92,265.76,306.04,260.97,306.04z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M314.96,306.04h-21.95c-4.78,0-8.66,3.88-8.66,8.66c0,4.78,3.88,8.66,8.66,8.66h21.95 c4.78,0,8.66-3.88,8.66-8.66C323.62,309.92,319.74,306.04,314.96,306.04z"
		})
	] })]
});
const ForwardRef = forwardRef(SvgN600Aging);
export { ForwardRef as ReactComponent };
